import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import your translation files
import enTranslation from './locales/en.json';
import arTranslation from './locales/ar.json';

// Retrieve the current language from localStorage
const currentLang = localStorage.getItem('current_lang') || 'en'; // Default to 'en' if not found

// Define the resources (translations)
const resources = {
  en: {
    translation: enTranslation
  },
  ar: {
    translation: arTranslation
  }
};

i18n
  .use(initReactI18next) // Passes i18n instance to react-i18next
  .init({
    resources,
    lng: currentLang, // Use the language retrieved from localStorage
    fallbackLng: 'en', // Fallback language if the current language isn't available
    interpolation: {
      escapeValue: false // React already handles escaping
    }
  });

export default i18n;
